window.addEventListener('load', function() {
    // --- Element References ---
    const playPauseBtn = document.getElementById('play-pause-btn');
    const progressBar = document.getElementById('progress-bar');
    const progressBarContainer = document.querySelector('#audio-player .progress-bar-container');
    const progressMarker = document.getElementById('progress-marker');
    const canvasContainer = document.getElementById('canvas-container');
    const canvas = document.getElementById('spaceCanvas');
    const ctx = canvas.getContext('2d');
    const threeCanvas = document.getElementById('threeCanvas');
    const sidebar = document.getElementById('sidebar');
    const sidebarTitle = document.getElementById('sidebar-title');
    const closeSidebarBtn = document.getElementById('close-sidebar');
    const openDrawerTab = document.getElementById('open-drawer-tab');
    const popoverContentPlaceholder = document.getElementById('popover-content-placeholder');
    const audioPlayerContainer = document.getElementById('audio-player-container');
    const galaxyPlaylistContainer = document.getElementById('galaxy-playlist-container');
    const timelineList = document.getElementById('timeline-list');
    const trackImageContainer = document.getElementById('track-image-container');
    const trackImage = document.getElementById('track-image');
    const audioPlayer = document.getElementById('audio-player');
    const releaseInfoDiv = document.getElementById('release-info');
    const waveformCanvas = document.getElementById('waveform-canvas');
    const waveformCtx = waveformCanvas.getContext('2d');
    const volumeSlider = document.getElementById('volume-slider');
    
    const cometProductContainer = document.getElementById('comet-product-image-container');
    const tidbitAudioContainer = document.getElementById('audio-player-container-tidbit');
    const klaviyoFormPlaceholder = document.getElementById('klaviyo-form-placeholder');
    const playPauseBtnTidbit = document.getElementById('play-pause-btn-tidbit');
    const progressBarTidbit = document.getElementById('progress-bar-tidbit');
    const progressMarkerTidbit = document.getElementById('progress-marker-tidbit');
    const progressBarContainerTidbit = tidbitAudioContainer.querySelector('.progress-bar-container');
    const waveformCanvasTidbit = document.getElementById('waveform-canvas-tidbit');
    const waveformCtxTidbit = waveformCanvasTidbit.getContext('2d');
    const volumeSliderTidbit = document.getElementById('volume-slider-tidbit');

    // --- State and Constants ---
    let nodes = [];
    let stars = [];
    let comets = [];
    let galaxy = { x: 0, y: 0 };
    const STAR_COUNT = 200;
    const NODE_RADIUS = 15;
    const SHOOTING_STAR_RADIUS = 4;
    let activeColor = { r: 46, g: 213, b: 133 };
    let inactiveColor = { r: 107, g: 114, b: 128 };
    const sallyStarColor = { r: 46, g: 213, b: 133 };
    const nostalgiaStarColor = { r: 249, g: 100, b: 182 };
    const inactiveContent = "Data Not Yet Received.";
    const releaseInfo = [
        { title: "Conversationally", content: "A decade-old demo re-opened like a time capsule: my 16-year-old self and my present self sharing the same song, ten years apart. Half preservation, half interruption: old vocals, naive and unfiltered, meet new production, sharper and stranger. Somewhere in between, a conversation unfolds...", active: true, color: {r: 46, g: 213, b: 133} },
        { title: "Parade of Consolations", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} },
        { title: "Not Yet Received", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} },
        { title: "Not Yet Received", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} },
        { title: "Not Yet Received", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} },
        { title: "Not Yet Received", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} },
        { title: "Not Yet Received", content: inactiveContent, active: false, color: {r: 107, g: 114, b: 128} }
    ];
    
    const cometInfo = {
        'spacelab': { type: 'spacelab', title: 'Star Seed: Spacelab', content: 'A recovered audio seed from a distant satellite.', color: {r: 167, g: 139, b: 250}, url: 'https://cdn.shopify.com/s/files/1/0674/7501/3830/files/SPACELAB.mp3?v=1754605346' },
        'femmeFatale': { type: 'femmeFatale', title: 'Star Seed: Femme Fatale', content: 'A recovered audio seed from a faraway world.', color: {r: 249, g: 100, b: 182}, url: 'https://cdn.shopify.com/s/files/1/0674/7501/3830/files/FEMME_FATALE.mp3?v=1754605343' }
    };

    let sidebarPlayer, sidebarWaveform;
    let isPlaying = false;
    let progressInterval;
    let isSidebarVisible = false;
    let sallyScore, nostalgiaScore, sallyPercent;
    let trackToAutoPlay = null;

    // --- Three.js Setup ---
    let scene, camera, renderer, imageGroup, glowSprite;
    let currentImageScale = 1;
    let currentGlowOpacity = 0;
    const frustumSize = 5;

    function createGlowTexture(color) {
        const canvas = document.createElement('canvas');
        canvas.width = 128;
        canvas.height = 128;
        const context = canvas.getContext('2d');
        const gradient = context.createRadialGradient(
            canvas.width / 2, canvas.height / 2, 0,
            canvas.width / 2, canvas.height / 2, canvas.width / 2
        );
        gradient.addColorStop(0.1, `rgba(${color.r}, ${color.g}, ${color.b}, 0.8)`);
        gradient.addColorStop(1, `rgba(${color.r}, ${color.g}, ${color.b}, 0)`);
        context.fillStyle = gradient;
        context.fillRect(0, 0, canvas.width, canvas.height);
        return new THREE.CanvasTexture(canvas);
    }

    function initThree() {
        scene = new THREE.Scene();
        const aspect = window.innerWidth / window.innerHeight;
        camera = new THREE.OrthographicCamera(frustumSize * aspect / -2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / -2, 1, 1000);
        renderer = new THREE.WebGLRenderer({ canvas: threeCanvas, alpha: true, antialias: true });
        renderer.setSize(window.innerWidth, window.innerHeight);
        renderer.setPixelRatio(window.devicePixelRatio);
        imageGroup = new THREE.Group();
        scene.add(imageGroup);
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(
            'https://cdn.shopify.com/s/files/1/0674/7501/3830/files/hand-eye-8.png?v=1753823786',
            (texture) => {
                const imageAspectRatio = texture.image.width / texture.image.height;
                const planeHeight = 2.0; 
                const planeWidth = planeHeight * imageAspectRatio;
                const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight);
                const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true });
                const centerImageMesh = new THREE.Mesh(geometry, material);
                imageGroup.add(centerImageMesh);
            }
        );
        const initialGlowColor = {r: 167, g: 139, b: 250};
        const glowTexture = createGlowTexture(initialGlowColor);
        const glowMaterial = new THREE.SpriteMaterial({ map: glowTexture, blending: THREE.AdditiveBlending, opacity: 0 });
        glowSprite = new THREE.Sprite(glowMaterial);
        glowSprite.scale.set(7, 7, 7); 
        imageGroup.add(glowSprite); 
        const ambientLight = new THREE.AmbientLight(0xffffff, 1);
        scene.add(ambientLight);
        camera.position.z = 5;
    }

    // --- Audio Setup ---
    function setupAudio() {
        if (typeof Tone === 'undefined') { console.error("Tone.js is not loaded."); return; }
        sidebarWaveform = new Tone.Waveform();
        try {
            sidebarPlayer = new Tone.Player().toDestination();
            sidebarPlayer.connect(sidebarWaveform);
            sidebarPlayer.sync().start(0);
            Tone.Transport.loop = false;
            handleVolumeChange({ target: volumeSlider });
        } catch (e) {
            console.error("Tone.js error:", e);
        }
    }

    // --- UI & Canvas Functions ---
    function setupVersusBar(){ sallyPercent = Math.random() * 60 + 20; const score1 = Math.floor(Math.random() * 9000000) + 1000000; const score2 = Math.floor(Math.random() * 9000000) + 1000000; sallyScore = sallyPercent > 50 ? Math.max(score1, score2) : Math.min(score1, score2); nostalgiaScore = sallyPercent > 50 ? Math.min(score1, score2) : Math.max(score1, score2); updateScoreDisplay(); }
    function updateScoreDisplay(){ const sallyBar = document.getElementById('sally-bar'); const nostalgiaBar = document.getElementById('nostalgia-bar'); const sallyCounter = document.getElementById('sally-counter'); const nostalgiaCounter = document.getElementById('nostalgia-counter'); if (!sallyBar || !nostalgiaBar || !sallyCounter || !nostalgiaCounter) return; sallyBar.style.width = `${sallyPercent}%`; nostalgiaBar.style.width = `${100 - sallyPercent}%`; sallyCounter.textContent = Math.round(sallyScore).toLocaleString(); nostalgiaCounter.textContent = Math.round(nostalgiaScore).toLocaleString(); }
    function updateScores(){ const change = (Math.random() - 0.5) * 50000; sallyScore += change; nostalgiaScore -= change; const totalScore = sallyScore + nostalgiaScore; sallyPercent = (sallyScore / totalScore) * 100; if (sallyPercent < 5) sallyPercent = 5; if (sallyPercent > 95) sallyPercent = 95; updateScoreDisplay(); updateStarColors(); }
    function setupStars(){ stars = []; if (!canvas) return; for (let i = 0; i < STAR_COUNT; i++) { stars.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, size: Math.random() * 2 + 1, opacity: Math.random() * 0.5 + 0.2, vx: (Math.random() - 0.5) * 0.01, vy: (Math.random() - 0.5) * 0.01, team: Math.random() < sallyPercent / 100 ? 'sally' : 'nostalgia' }); } }
    function updateStarColors(){ stars.forEach(star => { if (Math.random() < 0.01) { star.team = Math.random() < sallyPercent / 100 ? 'sally' : 'nostalgia'; } }); }
    function setupCanvas(){ if (!canvas) return; canvas.width = canvas.clientWidth; canvas.height = canvas.clientHeight; galaxy.x = canvas.width / 2; galaxy.y = canvas.height / 2; nodes = []; const numNodes = releaseInfo.length; const angleStep = (Math.PI * 2.5) / numNodes; const startRadius = Math.min(canvas.width, canvas.height) * 0.20; const endRadius = Math.min(canvas.width, canvas.height) * 0.45; const radiusRange = endRadius - startRadius; const targetAngleForFirstNode = Math.PI / 4; const angleOfLastSpiralPoint = (numNodes - 1) * angleStep; const angleOffset = targetAngleForFirstNode - angleOfLastSpiralPoint; releaseInfo.forEach((info, i) => { const reversedIndex = numNodes - 1 - i; const angle = angleOffset + reversedIndex * angleStep; const radius = startRadius + (reversedIndex * radiusRange) / (numNodes - 1); const x = galaxy.x + Math.cos(angle) * radius; const y = galaxy.y + Math.sin(angle) * radius; let color = info.active ? info.color : inactiveColor; nodes.push({ x, y, vy: (Math.random() - 0.5) * 0.04, radius: NODE_RADIUS, info, color, baseX: x, baseY: y }); }); }
    
    function createShootingStar() {
        if (!canvas || comets.length >= 2) return;
        const starTypes = Object.keys(cometInfo);
        const starType = starTypes[Math.floor(Math.random() * starTypes.length)];
        const starData = cometInfo[starType];
        const edge = Math.floor(Math.random() * 4);
        let x, y, vx, vy;
        const speed = 0.3 + Math.random() * 0.2;
        if (edge === 0) { x = 0; y = Math.random() * canvas.height; vx = speed; vy = (Math.random() - 0.5) * speed; }
        else if (edge === 1) { x = canvas.width; y = Math.random() * canvas.height; vx = -speed; vy = (Math.random() - 0.5) * speed; }
        else if (edge === 2) { x = Math.random() * canvas.width; y = 0; vx = (Math.random() - 0.5) * speed; vy = speed; }
        else { x = Math.random() * canvas.width; y = canvas.height; vx = (Math.random() - 0.5) * speed; vy = -speed; }
        comets.push({ x, y, vx, vy, radius: SHOOTING_STAR_RADIUS, info: starData, trail: [] });
    }

    function drawShootingStars() {
        if (!ctx) return;
        comets.forEach(star => {
            if (star.trail.length > 1) {
                const startPoint = star.trail[0];
                const endPoint = {x: star.x, y: star.y};
                const gradient = ctx.createLinearGradient(startPoint.x, startPoint.y, endPoint.x, endPoint.y);
                gradient.addColorStop(0, `rgba(${star.info.color.r}, ${star.info.color.g}, ${star.info.color.b}, 0)`);
                gradient.addColorStop(1, `rgba(${star.info.color.r}, ${star.info.color.g}, ${star.info.color.b}, 0.7)`);
                ctx.strokeStyle = gradient;
                ctx.lineWidth = 2;
                ctx.beginPath();
                ctx.moveTo(startPoint.x, startPoint.y);
                ctx.lineTo(endPoint.x, endPoint.y);
                ctx.stroke();
            }
            const gradient = ctx.createRadialGradient(star.x, star.y, 0, star.x, star.y, star.radius * 2);
            gradient.addColorStop(0, `rgba(255, 255, 255, 1)`);
            gradient.addColorStop(0.5, `rgba(${star.info.color.r}, ${star.info.color.g}, ${star.info.color.b}, 1)`);
            gradient.addColorStop(1, `rgba(${star.info.color.r}, ${star.info.color.g}, ${star.info.color.b}, 0)`);
            ctx.fillStyle = gradient;
            ctx.beginPath();
            ctx.arc(star.x, star.y, star.radius * 2, 0, Math.PI * 2);
            ctx.fill();
        });
    }

    function drawBackground(){ if (!ctx || !canvas) return; const computedStyle = getComputedStyle(document.documentElement); const startColor = computedStyle.getPropertyValue('--canvas-bg-start').trim(); const endColor = computedStyle.getPropertyValue('--canvas-bg-end').trim(); const centerX = canvas.width / 2; const centerY = canvas.height / 2; const outerRadius = Math.sqrt(centerX*centerX + centerY*centerY); const bgGradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, outerRadius); bgGradient.addColorStop(0, startColor); bgGradient.addColorStop(1, endColor); ctx.fillStyle = bgGradient; ctx.fillRect(0, 0, canvas.width, canvas.height); }
    function drawStars(){ if (!ctx) return; stars.forEach(star => { const color = star.team === 'sally' ? sallyStarColor : nostalgiaStarColor; ctx.fillStyle = `rgba(${color.r}, ${color.g}, ${color.b}, ${star.opacity})`; ctx.fillRect(star.x, star.y, star.size, star.size); }); }
    function drawLines(){ if (!ctx) return; ctx.lineWidth = 1; for (let i = 0; i < nodes.length - 1; i++) { const startNode = nodes[i]; const endNode = nodes[i + 1]; if (!startNode || !endNode) continue; const strokeStyle = startNode.info.active ? `rgba(${startNode.color.r}, ${startNode.color.g}, ${startNode.color.b}, 0.5)` : `rgba(107, 114, 128, 0.4)`; ctx.strokeStyle = strokeStyle; ctx.beginPath(); ctx.moveTo(startNode.x, startNode.y); ctx.lineTo(endNode.x, endNode.y); ctx.stroke(); } const lastNode = nodes[nodes.length - 1]; if (lastNode) { const strokeStyle = lastNode.info.active ? `rgba(${lastNode.color.r}, ${lastNode.color.g}, ${lastNode.color.b}, 0.5)` : `rgba(107, 114, 128, 0.4)`; ctx.strokeStyle = strokeStyle; ctx.beginPath(); ctx.moveTo(lastNode.x, lastNode.y); ctx.lineTo(galaxy.x, galaxy.y); ctx.stroke(); } }
    function drawNodes(){ if (!ctx) return; nodes.forEach(node => { const c = node.color; const gradient = ctx.createRadialGradient(node.x, node.y, 0, node.x, node.y, node.radius); gradient.addColorStop(0, `rgba(${c.r}, ${c.g}, ${c.b}, 1)`); gradient.addColorStop(0.7, `rgba(${c.r}, ${c.g}, ${c.b}, 0.8)`); gradient.addColorStop(1, `rgba(${c.r}, ${c.g}, ${c.b}, 0)`); ctx.fillStyle = gradient; ctx.beginPath(); ctx.arc(node.x, node.y, node.radius, 0, Math.PI * 2); ctx.fill(); ctx.fillStyle = 'rgba(255, 255, 255, 0.9)'; ctx.beginPath(); ctx.arc(node.x, node.y, node.radius / 3, 0, Math.PI * 2); ctx.fill(); }); }
    function drawYouAreHere(){ if (!ctx) return; const targetNode = nodes[0]; if (!targetNode) return; const bobble = Math.sin(Date.now() * 0.0015) * 4; const textX = targetNode.x - 45; const textY = targetNode.y - 45 + bobble; const arrowEndX = targetNode.x - targetNode.radius * 0.707; const arrowEndY = targetNode.y - targetNode.radius * 0.707; ctx.fillStyle = `rgba(${activeColor.r}, ${activeColor.g}, ${activeColor.b}, 0.9)`; ctx.font = "14px 'JetBrains Mono', monospace"; ctx.textAlign = "center"; ctx.fillText("YOU ARE HERE", textX, textY); ctx.strokeStyle = `rgba(${activeColor.r}, ${activeColor.g}, ${activeColor.b}, 0.9)`; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(textX + 10, textY + 10); ctx.lineTo(arrowEndX, arrowEndY); const angle = Math.atan2(arrowEndY - (textY + 10), arrowEndX - (textX + 10)); const headlen = 8; ctx.moveTo(arrowEndX, arrowEndY); ctx.lineTo(arrowEndX - headlen * Math.cos(angle - Math.PI / 6), arrowEndY - headlen * Math.sin(angle - Math.PI / 6)); ctx.moveTo(arrowEndX, arrowEndY); ctx.lineTo(arrowEndX - headlen * Math.cos(angle + Math.PI / 6), arrowEndY - headlen * Math.sin(angle + Math.PI / 6)); ctx.stroke(); }
    
    function drawWaveform(waveCtx, waveCanvas, wave) {
        if (!waveCtx || !waveCanvas || !wave) return;
        const accentColor = getComputedStyle(sidebar).getPropertyValue('--player-accent-color').trim();
        waveCtx.clearRect(0, 0, waveCanvas.width, waveCanvas.height);
        const values = wave.getValue();
        waveCtx.beginPath();
        waveCtx.lineWidth = 2;
        waveCtx.strokeStyle = accentColor;
        const sliceWidth = waveCanvas.width * 1.0 / values.length;
        let x = 0;
        for (let i = 0; i < values.length; i++) {
            const v = values[i] / 2 + 0.5;
            const y = v * waveCanvas.height;
            if (i === 0) { waveCtx.moveTo(x, y); } else { waveCtx.lineTo(x, y); }
            x += sliceWidth;
        }
        waveCtx.stroke();
    }
    
    function animate(){ 
        if (!canvas || !ctx || canvas.width === 0 || canvas.height === 0) { requestAnimationFrame(animate); return; } 
        ctx.clearRect(0, 0, canvas.width, canvas.height); 
        drawBackground(); 
        stars.forEach(star => { star.x += star.vx; star.y += star.vy; if (star.x < 0 || star.x > canvas.width) star.vx *= -1; if (star.y < 0 || star.y > canvas.height) star.vy *= -1; }); 
        drawStars(); 
        comets.forEach((comet, index) => {
            comet.x += comet.vx;
            comet.y += comet.vy;
            comet.trail.push({ x: comet.x, y: comet.y });
            if (comet.trail.length > 40) { comet.trail.shift(); }
            if (comet.x < -20 || comet.x > canvas.width + 20 || comet.y < -20 || comet.y > canvas.height + 20) {
                comets.splice(index, 1);
            }
        });
        drawShootingStars();
        nodes.forEach(node => { node.y += node.vy; node.vy += (node.baseY - node.y) * 0.0005; if (node.y < node.baseY - 10 || node.y > node.baseY + 10) node.vy *= -1; }); 
        drawLines(); 
        drawNodes(); 
        drawYouAreHere(); 
        if (imageGroup && sidebarWaveform && sidebarWaveform.getValue) { let targetScale = 1; if (sidebarWaveform.getValue().length > 0) { let sum = 0; for (let i = 0; i < sidebarWaveform.getValue().length; i++) { sum += Math.abs(sidebarWaveform.getValue()[i]); } const avg = sum / sidebarWaveform.getValue().length; targetScale = 1 + avg * 0.2; } const smoothing = 0.1; currentImageScale += (targetScale - currentImageScale) * smoothing; imageGroup.scale.set(currentImageScale, currentImageScale, currentImageScale); if (glowSprite) { let targetGlowOpacity = 0; if (isPlaying) { targetGlowOpacity = 0.5 + Math.sin(Date.now() * 0.002) * 0.2; } currentGlowOpacity += (targetGlowOpacity - currentGlowOpacity) * smoothing; glowSprite.material.opacity = currentGlowOpacity; glowSprite.scale.lerp(new THREE.Vector3(7, 7, 7), 0.1); } } 
        if (renderer && scene && camera) { renderer.render(scene, camera); } 
        
        if (isPlaying) {
            if (!audioPlayerContainer.classList.contains('hidden')) {
                drawWaveform(waveformCtx, waveformCanvas, sidebarWaveform);
            }
            if (!tidbitAudioContainer.classList.contains('hidden')) {
                drawWaveform(waveformCtxTidbit, waveformCanvasTidbit, sidebarWaveform);
            }
        } else {
            if (waveformCtx) waveformCtx.clearRect(0, 0, waveformCanvas.width, waveformCanvas.height);
            if (waveformCtxTidbit) waveformCtxTidbit.clearRect(0, 0, waveformCanvasTidbit.width, waveformCanvasTidbit.height);
        }
        requestAnimationFrame(animate); 
    }
    
    function hideSidebar(){ if (!isSidebarVisible || !sidebar || !openDrawerTab) return; stopPlayer(); sidebar.classList.remove('visible'); openDrawerTab.classList.remove('hidden'); isSidebarVisible = false; }
    function showSidebar(){ if (!sidebar || !openDrawerTab) return; sidebar.classList.add('visible'); openDrawerTab.classList.add('hidden'); isSidebarVisible = true; }
    function updateTimeline(selectedTitle){ if (!timelineList) return; timelineList.innerHTML = ''; releaseInfo.forEach(track => { const point = document.createElement('li'); point.className = `timeline-point ${track.active ? 'active' : ''}`; if (track.active) { point.addEventListener('click', () => { const node = nodes.find(n => n.info.title === track.title); if (node) { updateSidebarForNode(node); } }); } if (track.title === selectedTitle) { point.classList.add('selected'); } timelineList.appendChild(point); }); }
    
    function hideAllSidebarContent() {
        trackImageContainer.classList.add('hidden');
        audioPlayerContainer.classList.add('hidden');
        releaseInfoDiv.classList.add('hidden');
        galaxyPlaylistContainer.classList.add('hidden');
        cometProductContainer.classList.add('hidden');
        tidbitAudioContainer.classList.add('hidden');
        klaviyoFormPlaceholder.classList.add('hidden');
    }

    function setPlayerColor(color) {
        if (!sidebar) return;
        sidebar.style.setProperty('--player-accent-color', `rgb(${color.r}, ${color.g}, ${color.b})`);
        sidebar.style.setProperty('--player-accent-color-rgb', `${color.r}, ${color.g}, ${color.b}`);
    }

    function updateSidebarForNode(node){ 
        if (!sidebar) return; 
        stopPlayer();
        hideAllSidebarContent();

        const c = node.color; 
        setPlayerColor(c);
        sidebar.style.borderRightColor = `rgba(${c.r}, ${c.g}, ${c.b}, 0.5)`; 
        sidebar.style.boxShadow = `5px 0 30px rgba(${c.r}, ${c.g}, ${c.b}, 0.2)`; 
        sidebarTitle.style.color = `rgb(${c.r}, ${c.g}, ${c.b})`; 
        sidebarTitle.textContent = node.info.title; 
        popoverContentPlaceholder.textContent = node.info.content; 
        popoverContentPlaceholder.classList.remove('hidden');

        if (node.info.title === "Conversationally") { 
            trackImageContainer.classList.remove('hidden'); 
            trackImage.src = "https://cdn.shopify.com/s/files/1/0674/7501/3830/files/conversationally-final2.jpg?v=1753478138";
        }
        audioPlayerContainer.classList.remove('hidden'); 

        if (node.info.active) { 
            audioPlayer.classList.remove('hidden'); 
            releaseInfoDiv.classList.remove('hidden'); 
            playPauseBtn.disabled = true;
            sidebarPlayer.load("https://cdn.shopify.com/s/files/1/0674/7501/3830/files/Conversationally_6db33e8d-2df2-4673-99fd-e7e11b05f69c.mp3?v=1754689451")
                .then(() => {
                    playPauseBtn.disabled = false;
                    setTimeout(() => { if (waveformCanvas) { waveformCanvas.width = waveformCanvas.clientWidth; waveformCanvas.height = waveformCanvas.clientHeight; } }, 0); 
                    setTimeout(() => togglePlayback(), 100);
                });
        }
        updateTimeline(node.info.title); 
        if (!isSidebarVisible) showSidebar(); 
    }

    function updateSidebarForStarSeed(comet) {
        if (!sidebar) return;
        stopPlayer();
        hideAllSidebarContent();

        const c = comet.info.color;
        setPlayerColor(c);
        sidebar.style.borderRightColor = `rgba(${c.r}, ${c.g}, ${c.b}, 0.5)`;
        sidebar.style.boxShadow = `5px 0 30px rgba(${c.r}, ${c.g}, ${c.b}, 0.2)`;
        sidebarTitle.style.color = `rgb(${c.r}, ${c.g}, ${c.b})`;
        sidebarTitle.textContent = comet.info.title;
        popoverContentPlaceholder.textContent = comet.info.content;
        popoverContentPlaceholder.classList.remove('hidden');

        tidbitAudioContainer.classList.remove('hidden');
        playPauseBtnTidbit.disabled = true;
        sidebarPlayer.load(comet.info.url).then(() => {
            playPauseBtnTidbit.disabled = false;
            setTimeout(() => { if (waveformCanvasTidbit) { waveformCanvasTidbit.width = waveformCanvasTidbit.clientWidth; waveformCanvasTidbit.height = waveformCanvasTidbit.clientHeight; } }, 0);
            setTimeout(() => togglePlayback(), 100);
        });
        
        updateTimeline(null);
        if (!isSidebarVisible) showSidebar();
    }

    function updateSidebarForGalaxy(){ 
        if (!sidebar) return; 
        stopPlayer();
        hideAllSidebarContent();
        
        setPlayerColor({r: 167, g: 139, b: 250}); // Default to purple for galaxy view
        sidebar.style.borderColor = 'var(--border-color)'; 
        sidebar.style.boxShadow = '5px 0 40px rgba(var(--accent-purple-rgb), 0.3)'; 
        sidebarTitle.style.color = 'var(--accent-purple)'; 
        sidebarTitle.textContent = "Nostalgia-verse: Full Transmission"; 
        popoverContentPlaceholder.classList.add('hidden');
        galaxyPlaylistContainer.classList.remove('hidden'); 
        galaxyPlaylistContainer.innerHTML = ''; 
        releaseInfo.forEach(track => { const item = document.createElement('li'); item.className = `playlist-item ${track.active ? 'active' : 'inactive'}`; const iconSVG = track.active ? `<svg class="icon" viewBox="0 0 20 20" fill="currentColor"><path d="M4.018 15.59a.5.5 0 0 0 .816.372l10-7a.5.5 0 0 0 0-.744l-10-7A.5.5 0 0 0 4.018 2.41v13.18z"></path></svg>` : `<svg class="icon" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clip-rule="evenodd"></path></svg>`; item.innerHTML = `${iconSVG}<span>${track.title}</span>`; if (track.active) { item.addEventListener('click', () => { const activeNode = nodes.find(n => n.info.title === track.title); if (activeNode) { updateSidebarForNode(activeNode); } }); } galaxyPlaylistContainer.appendChild(item); }); 
        updateTimeline(null); 
        if (!isSidebarVisible) showSidebar(); 
    }
    function toggleSidebar(){ if (isSidebarVisible) { hideSidebar(); } else { updateSidebarForGalaxy(); } }
    
    // --- Playback Controls (FIXED) ---
    function stopPlayer() {
        if (typeof Tone === 'undefined' || !sidebarPlayer) return;
        Tone.Transport.stop(); // This stops the transport and resets its position to 0.
        isPlaying = false;
        
        // UI updates
        if(playPauseBtn) { playPauseBtn.classList.remove('playing'); playPauseBtn.title = 'Play'; }
        if(playPauseBtnTidbit) { playPauseBtnTidbit.classList.remove('playing'); playPauseBtnTidbit.title = 'Play Star Seed'; }
        if(progressBar) progressBar.style.width = '0%';
        if(progressMarker) progressMarker.style.left = '0%';
        if(progressBarTidbit) progressBarTidbit.style.width = '0%';
        if(progressMarkerTidbit) progressMarkerTidbit.style.left = '0%';
        
        // Clear the interval
        if(progressInterval) clearInterval(progressInterval);
    }

    async function togglePlayback(event) {
        if (event) event.stopPropagation();
        if (typeof Tone === 'undefined' || !sidebarPlayer || !sidebarPlayer.loaded) return;
        if (Tone.context.state !== 'running') {
            try { await Tone.start(); } catch(e) { console.error("Tone.start() failed", e); return; }
        }

        if (isPlaying) {
            Tone.Transport.pause();
            isPlaying = false;
            if(playPauseBtn) playPauseBtn.classList.remove('playing');
            if(playPauseBtnTidbit) playPauseBtnTidbit.classList.remove('playing');
            if(progressInterval) clearInterval(progressInterval);
        } else {
            Tone.Transport.start();
            isPlaying = true;
            if(playPauseBtn) playPauseBtn.classList.add('playing');
            if(playPauseBtnTidbit) playPauseBtnTidbit.classList.add('playing');
            progressInterval = setInterval(() => {
                if(!sidebarPlayer || !sidebarPlayer.loaded) return;
                const duration = sidebarPlayer.buffer.duration;
                const currentProgressPercent = (Tone.Transport.seconds / duration) * 100;
                if (Tone.Transport.seconds >= duration) {
                    stopPlayer();
                } else {
                    if (progressBar) progressBar.style.width = `${currentProgressPercent}%`;
                    if (progressMarker) progressMarker.style.left = `${currentProgressPercent}%`;
                    if (progressBarTidbit) progressBarTidbit.style.width = `${currentProgressPercent}%`;
                    if (progressMarkerTidbit) progressMarkerTidbit.style.left = `${currentProgressPercent}%`;
                }
            }, 100);
        }
    }

    function handleVolumeChange(event) { 
        if (!sidebarPlayer || !volumeSlider || !volumeSliderTidbit) return;
        const linearVolume = parseFloat(event.target.value);
        const db = linearVolume > 0 ? 20 * Math.log10(linearVolume) : -Infinity;
        sidebarPlayer.volume.value = db;
        volumeSlider.value = linearVolume;
        if (volumeSliderTidbit) volumeSliderTidbit.value = linearVolume;
    }
    
    function handleProgressBarClick(event) {
        const progressBarContainer = event.currentTarget;
        if (!sidebarPlayer || !sidebarPlayer.loaded) return;
        const rect = progressBarContainer.getBoundingClientRect();
        const clickX = event.clientX - rect.left;
        const progressPercent = clickX / rect.width;
        const newTime = progressPercent * sidebarPlayer.buffer.duration;
        Tone.Transport.seconds = newTime;
        if (progressBar) progressBar.style.width = `${progressPercent * 100}%`;
        if (progressMarker) progressMarker.style.left = `${progressPercent * 100}%`;
        if (progressBarTidbit) progressBarTidbit.style.width = `${progressPercent * 100}%`;
        if (progressMarkerTidbit) progressMarkerTidbit.style.left = `${progressPercent * 100}%`;
        if (!isPlaying) {
            togglePlayback();
        }
    }

    // --- Event Listeners ---
    if(volumeSlider) volumeSlider.addEventListener('input', handleVolumeChange);
    if(volumeSliderTidbit) volumeSliderTidbit.addEventListener('input', handleVolumeChange);
    document.addEventListener('mousedown', (event) => { 
        if (!sidebar || !canvas) return; 
        const isClickInsideSidebar = sidebar.contains(event.target); 
        const isClickOnOpenBtn = openDrawerTab && openDrawerTab.contains(event.target); 
        if (isClickOnOpenBtn) return; 
        if (event.target === canvas) { 
            const rect = canvas.getBoundingClientRect(); 
            const mouseX = event.clientX - rect.left; 
            const mouseY = event.clientY - rect.top; 
            let clickedComet = null;
            for (const comet of comets) {
                const dist = Math.sqrt(Math.pow(mouseX - comet.x, 2) + Math.pow(mouseY - comet.y, 2));
                if (dist < comet.radius + 5) { clickedComet = comet; break; }
            }
            if (clickedComet) { updateSidebarForStarSeed(clickedComet); return; }
            let clickedNode = null; 
            for (const node of nodes) { const dist = Math.sqrt(Math.pow(mouseX - node.x, 2) + Math.pow(mouseY - node.y, 2)); if (dist < node.radius) { clickedNode = node; break; } } 
            if (clickedNode) { updateSidebarForNode(clickedNode); return; } 
        } 
        if (isSidebarVisible && !isClickInsideSidebar) { hideSidebar(); } 
    });
    document.addEventListener('keydown', (event) => { if ((event.key === ' ' || event.key === 'Spacebar') && isSidebarVisible) { event.preventDefault(); togglePlayback(); } });
    if(playPauseBtn) playPauseBtn.addEventListener('click', togglePlayback);
    if(playPauseBtnTidbit) playPauseBtnTidbit.addEventListener('click', togglePlayback);
    if(closeSidebarBtn) closeSidebarBtn.addEventListener('click', hideSidebar);
    if(openDrawerTab) openDrawerTab.addEventListener('click', toggleSidebar);
    if (progressBarContainer) progressBarContainer.addEventListener('click', handleProgressBarClick);
    if (progressBarContainerTidbit) progressBarContainerTidbit.addEventListener('click', handleProgressBarClick);
    
    // --- Initialization ---
    let initialSetupDone = false;
    function initialize() {
        if (initialSetupDone) return;
        if (!canvasContainer || canvasContainer.clientWidth === 0) { requestAnimationFrame(initialize); return; }
        if (typeof THREE === 'undefined') { console.error("Three.js is not loaded."); return; }
        setupVersusBar();
        setupCanvas();
        setupStars();
        initThree(); 
        setupAudio();
        animate();
        setInterval(updateScores, 250);
        
        function spawnShootingStarLoop() {
            createShootingStar();
            const randomDelay = 20000 + Math.random() * 10000;
            setTimeout(spawnShootingStarLoop, randomDelay);
        }
        spawnShootingStarLoop();

        const urlParams = new URLSearchParams(window.location.search);
        trackToAutoPlay = urlParams.get('play');
        
        initialSetupDone = true;
        
        if (trackToAutoPlay) {
            const autoPlayNode = nodes.find(n => n.info.title.toLowerCase() === trackToAutoPlay.toLowerCase());
            if (autoPlayNode) {
                // A small delay to ensure the UI is ready
                setTimeout(() => {
                    updateSidebarForNode(autoPlayNode);
                }, 100);
            }
            trackToAutoPlay = null; // Clear it after use
        }
    }
    const resizeObserver = new ResizeObserver(() => { 
        if (!initialSetupDone) return; 
        setupCanvas(); 
        setupStars(); 
        if (renderer && camera) { 
            const aspect = window.innerWidth / window.innerHeight; 
            camera.left = frustumSize * aspect / -2; 
            camera.right = frustumSize * aspect / 2; 
            camera.top = frustumSize / 2; 
            camera.bottom = frustumSize / -2; 
            camera.updateProjectionMatrix(); 
            renderer.setSize(window.innerWidth, window.innerHeight); 
        } 
    });
    if (canvasContainer) { resizeObserver.observe(canvasContainer); }
    
    initialize();
});